var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import SkeletonTablePF from '@patternfly/react-component-groups/dist/dynamic/SkeletonTable';
var SkeletonTable = function (props) { return _jsx(SkeletonTablePF, __assign({}, props)); };
export default SkeletonTable;
//# sourceMappingURL=SkeletonTable.js.map